import {
  Button,
  Col,
  Form,
  Row,
  Select,
  Table,
  Tabs,
  notification
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import Intake from '../drawers/intakeList'
import { useDispatch, useSelector } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import {
  CampBellUniversity,
  CasaHCollege,
  ConditionOptions,
  DirectUniversityCheck,
  Intakes,
  ProgramLevel,
  RoyalArtsCollege,
  WavierYear,
  academicStatusList,
  displayDate,
  typeOfProgramList, CornerStoneCollege, NationalCollege, countryIds, KasaHighSchool
} from '../../../components/_utils/appUtils'
import { LoadState } from '../../../components/_utils/countryUtil'
import { listAllCourseCategory } from '../../CourseCategory/actions'
import { listAllCampus } from '../../campus/actions/campus'
import { indiaAllStates } from '../../state/actions/state'
import { listAllUniversities } from '../../university/actions/university'
import { addCourse } from '../actions/courseAction'
import EnglishRequirement from '../drawers/englishRequirement'
import InstallmentSchedule1 from '../drawers/installmentSchedule1'
import InstallmentSchedule2 from '../drawers/installmentSchedule2'
import QualificationDrawer from '../drawers/qualification'
import WaiversDrawer from '../drawers/waivers'
import { listAllCountries } from '../../countries/actions/countries'

const initialState = {
  univ: [],
  tabsAlert: [],
  ieltsRequirements: [],
  intake: [],
  qualifications: [],
  edit: false,
  rowKey: null,
  key: Math.random() * 100,
  universityCountry: '',
  universityState: '',
  universityCity: '',
  yearList: WavierYear(),
  waiverList: [],
  installmentSchedule1: [],
  installmentSchedule2: []
}
const InitialExamState = {
  examType: '',
  overall: '',
  listening: '',
  writing: '',
  speaking: '',
  reading: ''
}
const AddCourse = props => {
  const [state, setState] = useState(initialState)

  const [examState, setExamState] = useState(InitialExamState)
  const {
    form: { getFieldDecorator, setFieldsValue, getFieldValue, resetFields }
  } = props
  const [indiaStates, setIndiaStates] = useState([])
  const [visibleEnglishRequirement, setVisibleEnglishRequirement] = useState(
    false
  )
  const [editAbleEnglish, setEditAbleEnglish] = useState({})
  const [visibleQualification, setVisibleQualification] = useState(false)
  const [editAbleQualification, setEditAbleQualification] = useState({})
  const [editAbleWaiver, setEditAbleWaiver] = useState({})
  const [visibleWaiver, setVisibleWaiver] = useState(false)
  const [isDirectUniversity, setIsDirectUniversity] = useState(false)
  const [installmentSchedule1, setInstallmentSchedule1] = useState(false)
  const [installmentSchedule2, setInstallmentSchedule2] = useState(false)
  const [installmentData1, setInstallmentData1] = useState(false)
  const [installmentData2, setInstallmentData2] = useState(false)
  const [selectedUniversity, setSelectedUniversity] = useState('')
  const [pathway, setPathway] = useState(false)
  const [categoryList, setCategoryList] = useState([])
  const [visibleIntake, setVisibleIntake] = useState(false)
  const [editableIntake, setEditableIntake] = useState({})
  const [allCountries, setAllCountries] = useState([])
  const [allUniversities, setAllUniversities] = useState([])
  const dispatch = useDispatch()
  const { courseLoader, allCampus } = useSelector(
    state => ({
      courseLoader: state.addCourse.courseLoader,
      addedCourse: state.addCourse.addedCourse,
      allCampus: state.campusReducers.allCampus
        ? state.campusReducers.allCampus
        : []
    })
  )
  const loadCourseCategory = async () => {
    let obj = {
      results: 100,
      count: 100
    }
    let { data } = await dispatch(listAllCourseCategory(obj))
    setCategoryList(data)
  }

  const IndiaStates = async () => {
    let listOfState = await LoadState(101)
    setIndiaStates(listOfState)
  }

  useEffect(() => {
    IndiaStates()
    loadCourseCategory()
  }, [])

  // console.log(courseLoader, allUniversities)
  useEffect(() => {
    dispatch({ type: 'COURSE_HIDELOADER' })
    dispatch({ type: 'EMPTY_CAMPUS_LIST' })

    dispatch(indiaAllStates({ results: 1000000 }))
    setFieldsValue({ isFeatured: true, isSearchAble: true })
  }, [])

  useEffect(() => {
    loadUni()
  }, [getFieldValue('universityCountry')])

  let loadUni = async () => {
    if (getFieldValue('universityCountry')) {
      let { data } = await dispatch(
        listAllUniversities({
          results: 500,
          sortField: 'universityName',
          sortOrder: 'ascend',
          universityCountry: getFieldValue('universityCountry')
        })
      )
      setAllUniversities(data)
    } else {
      setAllUniversities([])
    }

  }

  const chooseUniversity = data => {
    if (data && data._id) {
      setState(() => ({
        ...state,
        universityCountry:
          data.universityCountry && data.universityCountry._id
            ? data.universityCountry._id
            : data.universityCountry,
        universityState:
          data.universityState && data.universityState._id
            ? data.universityState._id
            : data.universityState,
        universityCity:
          data.universityCity && data.universityCity._id
            ? data.universityCity._id
            : data.universityCity,
        universityName: data.universityName
      }))
    }
  }

  const validationCourseMonth = () => {
    if (getFieldValue('courseUniversity')) {
      if (getFieldValue('courseUniversity') == CornerStoneCollege) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  useEffect(() => {
    loadCountry()
  }, [])

  const loadCountry = async () => {
    let {data} = await dispatch(listAllCountries())
    setAllCountries(data)
  }

  let checkIsCyprus = () => {
    let courseUniversity = getFieldValue('courseUniversity');
    if (courseUniversity == KasaHighSchool || courseUniversity == CasaHCollege) {
      return true
    } else {
      return false
    }
  }
  let checkIsCyprusEcts = () => {
    let courseUniversity = getFieldValue('courseUniversity');
    if (courseUniversity == CasaHCollege) {
      return true
    } else {
      return false
    }
  }

  let inputTypes = {
    fields: [
      {key: 'courseName', label: 'Course Name', type: 'text', required: true},
      {
        key: 'universityCountry', label: 'Country', placeholder: 'Country', type: 'select', required: true,
        span: 8,
        options: allCountries,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.countryName}`,
        showSearch: true,
        onChange: x => {
          props.form.setFieldsValue({
            universityCountry: x,
            universityState: undefined,
            universityCity: undefined
          })

        }
      },
      {
        key: 'courseUniversity',
        label: 'University Name',
        type: 'select',
        options: allUniversities,
        showSearch: true,
        onSearch: v => {
          dispatch(
            listAllUniversities({
              results: 20,
              universityName: v,
              regExFilters: ['universityName']
            })
          )
        },
        keyAccessor: x => x._id,
        required: true,
        valueAccessor: x => `${x.universityName}`,
        onChange: x => {
          let findUni = _.find(allUniversities, item => {
            return item._id == x
          })
          chooseUniversity(findUni)
          handleCampusSelect(x)
          props.form.setFieldsValue({
            courseUniversity: x,
            campusName: undefined,
            pathway: false
          })
          setSelectedUniversity(x)
          setIsDirectUniversity(DirectUniversityCheck(x))
        }
      },
      {
        key: 'campusName',
        label: 'Campus Name',
        showSearch: true,
        type: 'select',
        options: allCampus,
        keyAccessor: x => x._id,
        mode: 'multiple',
        valueAccessor: x => `${x.campusName}`,
        onChange: x => {
          props.form.setFieldsValue({
            campusName: x
          })
        }
      },
      { key: 'courseDuration', label: 'Course Duration', required: true },
      {
        key: 'totalMonths',
        span: 8,
        label: 'Course total Months',
        type: 'number',
        hidden: !validationCourseMonth(),
        required: validationCourseMonth()
      },
      {
        key: 'courseLevel',
        label: 'Course Level',
        required: true,
        type: 'select',
        options: ProgramLevel,
        onChange: courseLevel => {
          props.form.setFieldsValue({ courseLevel })
        }
      },
      {
        key: 'categoryId',
        label: 'Course Category',
        // required: true,
        type: 'select',
        options: categoryList,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.name}`,
        onChange: categoryId => {
          props.form.setFieldsValue({ categoryId })
        }
      },
      {
        key: 'tuitionFee',
        label: 'Tuition Fees',
        type: 'number',
        required: true
      },

      { key: 'payable', label: 'Payable' },
      {
        key: 'intakes',
        label: 'Intakes',
        required: true,
        showSearch: false,
        type: 'select',
        mode: 'multiple',
        options: Intakes,
        onChange: intakes => {
          props.form.setFieldsValue({ intakes })
        }
      },

      {
        key: 'additionalRequirments',
        label: 'Additional Requirments',
        hidden:
          getFieldValue('courseUniversity') == CampBellUniversity
            ? true
            : false,
        type: 'textarea'
      },

      {
        key: 'ineligibleState',
        label: 'Ineligible State',
        type: 'select',
        hidden:
          getFieldValue('courseUniversity') == CampBellUniversity
            ? true
            : false,
        mode: 'multiple',
        options: indiaStates,
        keyAccessor: x => x.name,
        valueAccessor: x => `${x.name}`,
        onChange: x => {
          props.form.setFieldsValue({
            ineligibleState: x
          })
        }
      },
      {
        key: 'waiver',
        label: 'Waiver',
        hidden:
          getFieldValue('courseUniversity') == CampBellUniversity
            ? true
            : false,
        type: 'select',
        options: [{ name: 'Yes', value: true }, { name: 'No', value: false }],
        keyAccessor: x => x.value,
        valueAccessor: x => `${x.name}`,
        onChange: x => {
          props.form.setFieldsValue({
            waiver: x
          })
          setState({
            ...state,
            waiverList: []
          })
        }
      },
      {
        key: 'scholarship',
        label: 'Scholarship',
        hidden:
          getFieldValue('courseUniversity') == CampBellUniversity
            ? true
            : false,
        type: 'number'
      },
      {
        key: 'courseCode',
        label: 'Course Code',
        placeholder: 'Course Code',
        required: (getFieldValue('courseUniversity') == CampBellUniversity || getFieldValue('courseUniversity') == NationalCollege) ? true : false
      },

      {
        key: 'cricosCode',
        label: 'Cricos Code',
        hidden:
          getFieldValue('courseUniversity') == CampBellUniversity ? false : true
      },

      {
        key: 'isFeatured',
        span: 8,
        label: 'Featured Course',
        type: 'select',
        options: ConditionOptions,
        keyAccessor: x => x.value,
        valueAccessor: x => `${x.name}`,
        onChange: x => {
          props.form.setFieldsValue({
            isFeatured: x
          })
        }
      },
      /*  {
                key: 'isSearchAble',
                span: 8,
                label: 'Searchable',
                type: 'select',
                options: ConditionOptions,
                keyAccessor: x => x.value,
                valueAccessor: x => `${x.name}`,
                onChange: x => {
                  props.form.setFieldsValue({
                    isSearchAble: x
                  })
                }
              },*/
      {
        key: 'levelOfStudy',
        span: 8,
        label: 'Level Of Study',
        hidden: getFieldValue('courseUniversity') ? !isDirectUniversity : true,
        required: getFieldValue('courseUniversity') ? isDirectUniversity : false
      },
      {
        key: 'typeOfProgram',
        span: 8,
        label: 'Type Of Program',
        type: 'select',
        keyAccessor: x => x.value,
        valueAccessor: x => `${x.name}`,
        options: typeOfProgramList,
        hidden: getFieldValue('courseUniversity') ? !isDirectUniversity : true,
        required: getFieldValue('courseUniversity')
          ? isDirectUniversity
          : false,
        onChange: x => {
          props.form.setFieldsValue({
            typeOfProgram: x
          })
        }
      },


      {
        key: 'academicStatus',
        span: 8,
        label: 'Academic Status',
        options: academicStatusList,
        type: 'select',
        keyAccessor: x => x.value,
        valueAccessor: x => `${x.name}`,
        hidden: getFieldValue('courseUniversity') ? !isDirectUniversity : true,
        required: getFieldValue('courseUniversity')
          ? isDirectUniversity
          : false,
        onChange: x => {
          props.form.setFieldsValue({
            academicStatus: x
          })
        }
      },
      {
        key: 'hoursOfInstructionPerWeek',
        span: 8,
        label: 'Hours Of Instruction Per Week',
        hidden: getFieldValue('courseUniversity') ? !isDirectUniversity : true,
        required: getFieldValue('courseUniversity') ? isDirectUniversity : false
      },
      {
        key: 'startDate',
        span: 8,
        type: 'date',
        label: 'Start Date',
        hidden: getFieldValue('courseUniversity') ? !isDirectUniversity : true,
        required: getFieldValue('courseUniversity') ? isDirectUniversity : false
      },
      {
        key: 'endDate',
        span: 8,
        type: 'date',
        label: 'End Date',
        hidden: getFieldValue('courseUniversity') ? !isDirectUniversity : true,
        required: getFieldValue('courseUniversity') ? isDirectUniversity : false
      },
      {
        key: 'firstYearFees',
        span: 8,
        type: 'number',
        label: '1st Year Fees',
        hidden: getFieldValue('courseUniversity') ? !isDirectUniversity : true,
        required: getFieldValue('courseUniversity') ? isDirectUniversity : false
      },
      {
        key: 'secondYearFees',
        span: 8,
        type: 'number',
        label: '2nd Year Fees',
        hidden: getFieldValue('courseUniversity') ? !isDirectUniversity : true,
        required: getFieldValue('courseUniversity') ? isDirectUniversity : false
      },
      {
        key: 'pathway',
        span: 8,
        label: 'Pathway',
        type: 'select',
        options: ConditionOptions,
        hidden: getFieldValue('courseUniversity') ? !isDirectUniversity : true,
        required: getFieldValue('courseUniversity')
          ? isDirectUniversity
          : false,
        keyAccessor: x => x.value,
        valueAccessor: x => `${x.name}`,
        onChange: x => {
          setPathway(x)
          props.form.setFieldsValue({
            pathway: x
          })
        }
      },
      {
        key: 'secondYearStartDate',
        span: 8,
        type: 'date',
        label: '2nd Year Start Date',
        hidden: !getFieldValue('pathway'),
        required: getFieldValue('pathway')
      },
      {
        key: 'secondYearEndDate',
        span: 8,
        type: 'date',
        label: '2nd Year End Date',
        hidden: !getFieldValue('pathway'),
        required: getFieldValue('pathway')
      },
      {
        key: 'courseName2',
        label: 'Second Course Name',
        hidden:
          getFieldValue('courseUniversity') == CampBellUniversity &&
          getFieldValue('pathway') == true
            ? false
            : true
      },
      {
        key: 'cricosCode2',
        label: 'Cricos Code for Second Course',
        hidden:
          getFieldValue('courseUniversity') == CampBellUniversity &&
          getFieldValue('pathway') == true
            ? false
            : true
      },
      {
        key: 'courseCode2',
        label: 'Course Code for second Course',
        hidden:
          getFieldValue('courseUniversity') == CampBellUniversity &&
          getFieldValue('pathway') == true
            ? false
            : true
      },
      {
        key: 'courseDuration2',
        label: 'Course Duration for second Course',
        hidden:
          getFieldValue('courseUniversity') == CampBellUniversity &&
          getFieldValue('pathway') == true
            ? false
            : true
      },
      {
        key: 'ectsCredit',
        label: 'ECTS Credits',
        placeholder: 'ECTS Credits',
        type: 'number',
        hidden: !checkIsCyprusEcts(),
        required: checkIsCyprusEcts()
      },
      {
        key: 'afterArrivalFees',
        label: 'After Arrival Fees',
        placeholder: 'After Arrival Fees',
        type: 'number',
        hidden: !checkIsCyprus(),
        required: checkIsCyprus()
      },
      {
        key: 'visaGuarantee',
        label: 'Visa Guarantee',
        placeholder: 'Visa Guarantee',
        type: 'number',
        hidden: !checkIsCyprus(),
        required: checkIsCyprus()
      },
      {
        key: 'annualLivingExpense',
        label: 'Annual Living Expenses',
        placeholder: 'Annual Living Expenses',
        type: 'number',
        hidden: !checkIsCyprus(),
        required: checkIsCyprus()
      },
      {
        key: 'semesters',
        label: 'Semesters',
        placeholder: 'Semesters',
        type: 'number',
        hidden: !checkIsCyprus(),
        required: checkIsCyprus()
      },
      {
        key: 'faculty',
        label: 'Faculty',
        // placeholder: 'faculty',
        type: 'string',
        hidden:
            getFieldValue('courseUniversity') == RoyalArtsCollege ? false : true,
        required:
            getFieldValue('courseUniversity') == RoyalArtsCollege ? true : false
      },
      {
        key: 'session',
        label: 'Session',
        // placeholder: 'Session',
        type: 'string',
        hidden:
          getFieldValue('courseUniversity') == RoyalArtsCollege ? false : true,
        required:
          getFieldValue('courseUniversity') == RoyalArtsCollege ? true : false
      },
      {
        key: 'responseDeadline',
        label: 'Response Deadline',
        placeholder: 'Select Date',
        type: 'date',
        hidden:
          getFieldValue('courseUniversity') == RoyalArtsCollege ? false : true,
        required:
          getFieldValue('courseUniversity') == RoyalArtsCollege ? true : false
      }
    ]
  }
  const handleCampusSelect = x => {
    dispatch(
      listAllCampus({ results: 1000000, customQuery: { campusUniversity: x } })
    )
  }
  const addExam = data => {
    if (data.examType) {
      let findExists = _.find(state.ieltsRequirements, (item, key) => {
        if (data.edit) {
          return item.examType == data.examType && data.rowKey !== key
        } else {
          return item.examType == data.examType
        }
      })
      if (findExists) {
        notification.warning({
          message: 'English requirement already exists.'
        })
        return
      }

      if (data.edit) {
        const clone = _.cloneDeep(state.ieltsRequirements)
        clone[data.rowKey] = {
          examType: data.examType,
          // qualification: data.qualification,
          overall: data.overall,
          listening: data.listening,
          reading: data.reading,
          writing: data.writing,
          speaking: data.speaking
        }
        setState({ ...state, ieltsRequirements: clone })
        setExamState(InitialExamState)
        setVisibleEnglishRequirement(false)
      } else {
        let obj = {
          examType: data.examType,
          // qualification: data.qualification,
          overall: data.overall,
          listening: data.listening,
          reading: data.reading,
          writing: data.writing,
          speaking: data.speaking
        }
        setState({
          ...state,
          ieltsRequirements: [...state.ieltsRequirements, obj]
        })
        setExamState(InitialExamState)
        setVisibleEnglishRequirement(false)
      }
    }
  }
  const editExamType = (item, rowKey) => {
    setEditAbleEnglish({ ...item, edit: true, rowKey })
    setVisibleEnglishRequirement(true)
  }
  const editQualification = (item, rowKey) => {
    setEditAbleQualification({ ...item, edit: true, rowKey })
    setVisibleQualification(true)
  }
  const deleteExamType = (item, rowKey) => {
    let clone = _.cloneDeep(state.ieltsRequirements)
    clone.splice(rowKey, 1)
    setState(() => ({
      ...state,
      ieltsRequirements: clone
    }))
  }
  const deleteQualification = (item, rowKey) => {
    let clone = _.cloneDeep(state.qualifications)
    clone.splice(rowKey, 1)
    setState(() => ({
      ...state,
      qualifications: clone
    }))
  }
  const addQualification = values => {
    let findExists = _.find(state.qualifications, (item, key) => {
      if (values.edit) {
        return (
          item.qualification == values.qualification && values.rowKey !== key
        )
      } else {
        return item.qualification == values.qualification
      }
    })
    if (findExists) {
      notification.warning({
        message: 'Education already exists.'
      })
      return
    }

    if (values.edit) {
      const clone = _.cloneDeep(state.qualifications)
      clone[values.rowKey] = {
        qualification: values.qualification ? values.qualification : '',
        passingYear: values.passingYear ? values.passingYear : '',
        percentage: values.percentage ? values.percentage : '',
        maths: values.maths ? values.maths : '',
        english: values.english ? values.english : '',
        stream: values.stream ? values.stream : '',
        major: values.major ? values.major : '',
        backlogs: values.backlogs ? values.backlogs : '',
        degreeType: values.degreeType ? values.degreeType : ''
      }
      setState({ ...state, qualifications: clone })
      setVisibleQualification(false)
    } else {
      let obj = {
        qualification: values.qualification ? values.qualification : '',
        passingYear: values.passingYear ? values.passingYear : '',
        percentage: values.percentage ? values.percentage : '',
        maths: values.maths ? values.maths : '',
        english: values.english ? values.english : '',
        stream: values.stream ? values.stream : '',
        major: values.major ? values.major : '',
        backlogs: values.backlogs ? values.backlogs : '',
        degreeType: values.degreeType ? values.degreeType : ''
      }
      setState({
        ...state,
        qualifications: [...state.qualifications, obj]
      })
      setVisibleQualification(false)
    }
  }

  const editInstallment1 = (item, rowKey) => {
    setInstallmentData1({ ...item, edit: true, rowKey })
    setInstallmentSchedule1(true)
  }

  const editInstallment2 = (item, rowKey) => {
    setInstallmentData2({ ...item, edit: true, rowKey })
    setInstallmentSchedule2(true)
  }

  const deleteInstallment1 = (item, rowKey) => {
    let clone = _.cloneDeep(state.installmentSchedule1)
    clone.splice(rowKey, 1)
    setState(() => ({
      ...state,
      installmentSchedule1: clone
    }))
  }
  const deleteInstallment2 = (item, rowKey) => {
    let clone = _.cloneDeep(state.installmentSchedule2)
    clone.splice(rowKey, 1)
    setState(() => ({
      ...state,
      installmentSchedule2: clone
    }))
  }

  const installmentColumn1 = [
    {
      title: 'Study Period',
      dataIndex: 'studyPeriod',
      key: 'studyPeriod'
    },
    {
      title: 'Due Date',
      dataIndex: 'dueDate',
      key: 'dueDate',
      required: true,
      render: item => {
        return displayDate(item)
      }
    },
    {
      title: 'Application Fee',
      dataIndex: 'applicationFee',
      key: 'applicationFee'
    },
    {
      title: 'Material Fee',
      dataIndex: 'materialFee',
      key: 'materialFee'
    },
    {
      title: 'Tuition Fee',
      dataIndex: 'tuitionFee',
      key: 'tuitionFee'
    },

    {
      title: 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (key, val, rowKey) => {
        return (
          <div className={'pa-0'}>
            <Button
              shape='circle'
              size={'small'}
              icon='edit'
              id={'edit'}
              onClick={() => editInstallment1(val, rowKey)}
            />
            <Button
              style={{ marginLeft: 6 }}
              size={'small'}
              color={'red'}
              shape='circle'
              icon='delete'
              id={'delete'}
              onClick={() => deleteInstallment1(val, rowKey)}
            />
          </div>
        )
      }
    }
  ]

  const installmentColumn2 = [
    {
      title: 'Study Period',
      dataIndex: 'studyPeriod',
      key: 'studyPeriod'
    },
    {
      title: 'Due Date',
      dataIndex: 'dueDate',
      key: 'dueDate',
      required: true,
      render: item => {
        return displayDate(item)
      }
    },
    {
      title: 'Application Fee',
      dataIndex: 'applicationFee',
      key: 'applicationFee'
    },
    {
      title: 'Material Fee',
      dataIndex: 'materialFee',
      key: 'materialFee'
    },
    {
      title: 'Tuition Fee',
      dataIndex: 'tuitionFee',
      key: 'tuitionFee'
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (key, val, rowKey) => {
        return (
          <div className={'pa-0'}>
            <Button
              shape='circle'
              size={'small'}
              icon='edit'
              id={'edit'}
              onClick={() => editInstallment2(val, rowKey)}
            />
            <Button
              style={{ marginLeft: 6 }}
              size={'small'}
              color={'red'}
              shape='circle'
              icon='delete'
              id={'delete'}
              onClick={() => deleteInstallment2(val, rowKey)}
            />
          </div>
        )
      }
    }
  ]

  const addInstallments = data => {
    if (data.edit) {
      const clone = _.cloneDeep(state.installmentSchedule1)
      clone[data.rowKey] = {
        studyPeriod: data.studyPeriod,
        dueDate: data.dueDate,
        applicationFee: data.applicationFee,
        materialFee: data.materialFee,
        tuitionFee: data.tuitionFee
      }
      setState({ ...state, installmentSchedule1: clone })
      setInstallmentData1({})
      setInstallmentSchedule1(false)
    } else {
      let obj = {
        studyPeriod: data.studyPeriod,
        dueDate: data.dueDate,
        applicationFee: data.applicationFee,
        materialFee: data.materialFee,
        tuitionFee: data.tuitionFee
      }
      setState({
        ...state,
        installmentSchedule1: [...state.installmentSchedule1, obj]
      })
      setInstallmentData1({})
      setInstallmentSchedule1(false)
    }
  }

  const addInstallments2 = data => {
    if (data.edit) {
      const clone = _.cloneDeep(state.installmentSchedule2)
      clone[data.rowKey] = {
        studyPeriod: data.studyPeriod,
        dueDate: data.dueDate,
        applicationFee: data.applicationFee,
        materialFee: data.materialFee,
        tuitionFee: data.tuitionFee
      }
      setState({ ...state, installmentSchedule2: clone })
      setInstallmentData2({})
      setInstallmentSchedule2(false)
    } else {
      let obj = {
        studyPeriod: data.studyPeriod,
        dueDate: data.dueDate,
        applicationFee: data.applicationFee,
        materialFee: data.materialFee,
        tuitionFee: data.tuitionFee
      }
      setState({
        ...state,
        installmentSchedule2: [...state.installmentSchedule2, obj]
      })
      setInstallmentData2({})
      setInstallmentSchedule2(false)
    }
  }

  const addWaiver = values => {
    let findExists = _.find(state.waiverList, (item, key) => {
      if (values.edit) {
        return item.board == values.board && values.rowKey !== key
      } else {
        return item.board == values.board
      }
    })
    if (findExists) {
      notification.warning({
        message: 'Board already exists.'
      })
      return
    }

    if (values.edit) {
      const clone = _.cloneDeep(state.waiverList)
      clone[values.rowKey] = {
        board: values.board ? values.board : '',
        year: values.year ? values.year : '',
        percentage: values.percentage ? values.percentage : ''
      }
      setState({ ...state, waiverList: clone })
      setVisibleWaiver(false)
      setEditAbleWaiver({})
    } else {
      let obj = {
        board: values.board ? values.board : '',
        year: values.year ? values.year : '',
        percentage: values.percentage ? values.percentage : ''
      }
      setState({
        ...state,
        waiverList: [...state.waiverList, obj]
      })
      setVisibleWaiver(false)
      setEditAbleWaiver({})
    }
  }

  const editWavier = (item, rowKey) => {
    setEditAbleWaiver({ ...item, edit: true, rowKey })
    setVisibleWaiver(true)
  }
  const closeWavier = (item, rowKey) => {
    setVisibleWaiver(false)
    setEditAbleWaiver({})
  }
  const deleteWaiver = (item, rowKey) => {
    let clone = _.cloneDeep(state.waiverList)
    clone.splice(rowKey, 1)
    setState(() => ({
      ...state,
      waiverList: clone
    }))
  }
  const addIntake = data => {
    if (data.month && data.year) {
      let findExists = _.find(state.intake, (item, key) => {
        if (data.edit) {
          return (
            item.month === data.month &&
            item.year === data.year &&
            data.rowKey !== key
          )
        } else {
          return item.month === data.month && item.year === data.year
        }
      })

      if (findExists) {
        notification.warning({
          message: 'Intake already exists.'
        })
        return
      }

      if (data.edit) {
        const clone = _.cloneDeep(state.intake)
        clone[data.rowKey] = {
          month: data.month,
          year: data.year,
          startDate: data.startDate,
          endDate: data.endDate,
          secondYearStartDate: data.secondYearStartDate,
          secondYearEndDate: data.secondYearEndDate,
          active: data.active
        }
        setState({ ...state, intake: clone })
        setVisibleIntake(false)
      } else {
        let obj = {
          month: data.month,
          year: data.year,
          startDate: data.startDate,
          endDate: data.endDate,
          secondYearStartDate: data.secondYearStartDate,
          secondYearEndDate: data.secondYearEndDate,
          active: data.active
        }
        setState({
          ...state,
          intake: [...state.intake, obj]
        })
        setVisibleIntake(false)
      }
    }
  }
  const editIntake = (item, rowKey) => {
    setEditableIntake({ ...item, edit: true, rowKey })
    setVisibleIntake(true)
  }
  const deleteIntakeEntry = (item, rowKey) => {
    let clone = _.cloneDeep(state.intake)
    clone.splice(rowKey, 1)
    setState(() => ({
      ...state,
      intake: clone
    }))
  }
  const intakeColumns = [
    {
      title: 'Month',
      dataIndex: 'month',
      key: 'month'
    },
    {
      title: 'Year',
      dataIndex: 'year',
      key: 'year'
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (item, record) => {
        return `${moment(record.startDate).format('D MMM  YY')}`
      }
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (item, record) => {
        return `${moment(record.endDate).format('D MMM  YY')}`
      }
    },
    {
      title: 'Active',
      dataIndex: 'active',
      key: 'active',

      render: active => (
        <span>
          {active ? 'Active' : 'Inactive'}
        </span>
      )
    },
    {
      title: '2nd Year StartDate',
      dataIndex: 'secondYearStartDate',
      key: 'secondYearStartDate',
      render: (item, record) => {
        return `${moment(record.secondYearStartDate).format('D MMM  YY')}`
      }
    },
    {
      title: '2nd Year EndDate',
      dataIndex: 'secondYearEndDate',
      key: 'secondYearEndDate',
      render: (item, record) => {
        return `${moment(record.secondYearEndDate).format('D MMM  YY')}`
      }
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (key, val, rowKey) => (
        <div className={'pa-0'}>
          <Button
            shape='circle'
            size={'small'}
            icon='edit'
            id={'edit'}
            onClick={() => editIntake(val, rowKey)}
          />
          <Button
            style={{ marginLeft: 6 }}
            size={'small'}
            color={'red'}
            shape='circle'
            icon='delete'
            id={'delete'}
            onClick={() => deleteIntakeEntry(val, rowKey)}
          />
        </div>
      )
    }
  ]

  const ieltsColumn = [
    {
      title: 'Exam',
      dataIndex: 'examType',
      key: 'examType'
    },

    {
      title: 'Overall',
      dataIndex: 'overall',
      key: 'overall'
    },
    {
      title: 'Listening',
      dataIndex: 'listening',
      key: 'listening'
    },
    {
      title: 'Reading',
      dataIndex: 'reading',
      key: 'reading'
    },
    {
      title: 'Writing',
      dataIndex: 'writing',
      key: 'writing'
    },
    {
      title: 'Speaking',
      dataIndex: 'speaking',
      key: 'speaking'
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (key, val, rowKey) => {
        return (
          <div className={'pa-0'}>
            <Button
              shape='circle'
              size={'small'}
              icon='edit'
              id={'edit'}
              onClick={() => editExamType(val, rowKey)}
            />
            <Button
              style={{ marginLeft: 6 }}
              size={'small'}
              color={'red'}
              shape='circle'
              icon='delete'
              id={'delete'}
              onClick={() => deleteExamType(val, rowKey)}
            />
          </div>
        )
      }
    }
  ]
  const qualificationsCoulmn = [
    {
      title: 'Qualification',
      dataIndex: 'qualification',
      key: 'qualification'
    },
    {
      title: 'Passing Year',
      dataIndex: 'passingYear',
      key: 'passingYear'
    },
    {
      title: 'Percentage',
      dataIndex: 'percentage',
      key: 'percentage'
    },
    {
      title: 'Maths',
      dataIndex: 'maths',
      key: 'maths'
    },
    {
      title: 'English',
      dataIndex: 'english',
      key: 'english'
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (key, val, rowKey) => {
        return (
          <div className={'pa-0'}>
            <Button
              shape='circle'
              size={'small'}
              icon='edit'
              id={'edit'}
              onClick={() => editQualification(val, rowKey)}
            />
            <Button
              style={{ marginLeft: 6 }}
              size={'small'}
              color={'red'}
              shape='circle'
              icon='delete'
              id={'delete'}
              onClick={() => deleteQualification(val, rowKey)}
            />
          </div>
        )
      }
    }
  ]
  const waiverColumn = [
    {
      title: 'Board',
      dataIndex: 'board',
      key: 'board'
    },
    {
      title: 'Year',
      dataIndex: 'year',
      key: 'year'
    },
    {
      title: 'Percentage',
      dataIndex: 'percentage',
      key: 'percentage'
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (key, val, rowKey) => {
        return (
          <div className={'pa-0'}>
            <Button
              shape='circle'
              size={'small'}
              icon='edit'
              id={'edit'}
              onClick={() => editWavier(val, rowKey)}
            />
            <Button
              style={{ marginLeft: 6 }}
              size={'small'}
              color={'red'}
              shape='circle'
              icon='delete'
              id={'delete'}
              onClick={() => deleteWaiver(val, rowKey)}
            />
          </div>
        )
      }
    }
  ]
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }
  const onClose = () => {
    setState(() => ({ ...state, edit: false, examType: '' }))
    setExamState(() => InitialExamState)
  }
  const handleSubmit = e => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (state.qualifications)
        valData.qualification = [...state.qualifications]
      if (state.ieltsRequirements)
        valData.englishRequirments = [...state.ieltsRequirements]
      if (state.intake) valData.intakeList = [...state.intake]
      if (state.waiverList) valData.waiverList = [...state.waiverList]
      if (state.universityCountry)
        valData.universityCountry = state.universityCountry
      if (state.universityState) valData.universityState = state.universityState
      if (state.universityCity) valData.universityCity = state.universityCity
      if (state.universityName) valData.universityName = state.universityName
      if (state.installmentSchedule1)
        valData.installmentSchedule1 = state.installmentSchedule1
      if (state.installmentSchedule2)
        valData.installmentSchedule2 = state.installmentSchedule2

      if (!err) {
        let data = await dispatch(addCourse(valData))
        if (data && !data.error) {
          form.resetFields()
          setState(() => ({ ...initialState, key: Math.random() * 100 }))
          setExamState(() => InitialExamState)
        }
      } else {
        // console.log(err)
        notification.warning({
          message: 'Fill All Required Fields'
        })
      }
    })
  }
  return (
    <div>
      <div className='row'>
        <div className='col-lg-12'>
          <Form
            onSubmit={handleSubmit}
            style={{ marginTop: 8, textAlign: 'left' }}
            noValidate>
            <div className='form-box mt-4'>
              <div className='d-flex align-items-center mb-3 heading-form'>
                <h5>course general details</h5>
              </div>

              <div className='card unizportal'>
                <Row gutter={24} className={'rowWrap'}>
                  {inputTypes.fields.map((item, key) => {
                    return item.hidden == undefined ||
                    (item.hidden !== undefined && !item.hidden) ? (
                      <Col
                        span={item.span ? item.span : 8}
                        md={item.span ? item.span : 8}
                        sm={12}
                        xs={24}
                        key={key}>
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={formItemLayout}
                        />
                      </Col>
                    ) : null
                  })}
                </Row>
                <Form.Item>
                  <Button
                    type='primary'
                    htmlType='submit'
                    className='btn'
                    loading={courseLoader}>
                    SAVE
                  </Button>
                </Form.Item>
              </div>
            </div>

            {getFieldValue('waiver') ? (
              <div className='form-box mt-4'>
                <div className='d-flex align-items-center mb-3 heading-form'>
                  <h5>Waivers</h5>
                  <a
                    className='btn ml-auto manage'
                    onClick={() => {
                      setVisibleWaiver(true)
                      setEditAbleEnglish({})
                    }}>
                    manage
                  </a>
                </div>

                <div className='card unizportal'>
                  <div className='card-body table-responsive p-0'>
                    <Table
                      pagination={false}
                      columns={waiverColumn}
                      dataSource={state.waiverList}
                      rowKey='key'
                    />
                  </div>
                </div>
              </div>
            ) : null}

            <div className='form-box mt-4'>
              <div className='d-flex align-items-center mb-3 heading-form'>
                <h5>English requirements</h5>
                <a
                  className='btn ml-auto manage'
                  onClick={() => {
                    setVisibleEnglishRequirement(true)
                    setEditAbleEnglish({})
                  }}>
                  manage
                </a>
              </div>

              <div className='card unizportal'>
                <div className='card-body table-responsive p-0'>
                  <Table
                    pagination={false}
                    columns={ieltsColumn}
                    dataSource={state.ieltsRequirements}
                    rowKey='key'
                  />
                </div>
              </div>
            </div>
            <div className='form-box mt-4'>
              <div className='d-flex align-items-center mb-3 heading-form'>
                <h5>Qualification</h5>
                <a
                  className='btn ml-auto manage'
                  onClick={() => {
                    setVisibleQualification(true)
                    setEditAbleQualification({})
                  }}>
                  manage
                </a>
              </div>

              <div className='card unizportal'>
                <div className='card-body table-responsive p-0'>
                  <Table
                    pagination={false}
                    columns={qualificationsCoulmn}
                    dataSource={state.qualifications}
                    rowKey='key'
                  />
                </div>
              </div>
            </div>

            {selectedUniversity == CampBellUniversity ? (
              <div className='form-box mt-4'>
                <div className='d-flex align-items-center mb-3 heading-form'>
                  <h5>Installments Schedule for Course 1</h5>
                  <a
                    className='btn ml-auto manage'
                    onClick={() => {
                      setInstallmentSchedule1(true)
                    }}>
                    manage
                  </a>
                </div>

                <div className='card unizportal'>
                  <div className='card-body table-responsive p-0'>
                    <Table
                      pagination={false}
                      columns={installmentColumn1}
                      dataSource={state.installmentSchedule1}
                      rowKey='key'
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {selectedUniversity == CampBellUniversity && pathway ? (
              <div className='form-box mt-4'>
                <div className='d-flex align-items-center mb-3 heading-form'>
                  <h5>Installments Schedule for Course 2</h5>
                  <a
                    className='btn ml-auto manage'
                    onClick={() => {
                      setInstallmentSchedule2(true)
                    }}>
                    manage
                  </a>
                </div>

                <div className='card unizportal'>
                  <div className='card-body table-responsive p-0'>
                    <Table
                      pagination={false}
                      columns={installmentColumn2}
                      dataSource={state.installmentSchedule2}
                      rowKey='key'
                    />
                  </div>
                </div>
              </div>
            ) : null}
            {selectedUniversity &&
            DirectUniversityCheck(selectedUniversity) ? (
              <div className='form-box mt-4'>
                <div className='d-flex align-items-center mb-3 heading-form'>
                  <h5>Intake List</h5>
                  <a
                    className='btn ml-auto manage'
                    onClick={() => {
                      setVisibleIntake(true)
                      setEditableIntake({})
                    }}>
                    manage
                  </a>
                </div>

                <div className='card unizportal'>
                  <div className='card-body table-responsive p-0'>
                    <Table
                      pagination={false}
                      columns={intakeColumns}
                      dataSource={state.intake}
                      rowKey='key'
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </Form>
        </div>
      </div>

      {visibleEnglishRequirement && (
        <EnglishRequirement
          visible={visibleEnglishRequirement}
          data={editAbleEnglish}
          addEnglishReq={data => addExam(data)}
          onClose={data => setVisibleEnglishRequirement(false)}
        />
      )}

      {visibleQualification && (
        <QualificationDrawer
          visible={visibleQualification}
          data={editAbleQualification}
          addQualificationReq={data => addQualification(data)}
          onClose={data => setVisibleQualification(false)}
        />
      )}

      {visibleWaiver && (
        <WaiversDrawer
          visible={visibleWaiver}
          data={editAbleWaiver}
          addWaiverReq={data => addWaiver(data)}
          onClose={data => closeWavier()}
        />
      )}

      {installmentSchedule1 && (
        <InstallmentSchedule1
          visible={installmentSchedule1}
          data={installmentData1}
          addInstallment1Data={data => addInstallments(data)}
          onClose={data => setInstallmentSchedule1(false)}
        />
      )}
      {visibleIntake && (
        <Intake
          pathway={pathway}
          visible={visibleIntake}
          data={editableIntake}
          addIntakeFxn={data => addIntake(data)}
          onClose={data => setVisibleIntake(false)}
        />
      )}

      {installmentSchedule2 && (
        <InstallmentSchedule2
          visible={installmentSchedule2}
          data={installmentData2}
          addInstallment2Data={data => addInstallments2(data)}
          onClose={data => setInstallmentSchedule2(false)}
        />
      )}

    </div>
  )
}
const WrappedComponent = Form.create()(AddCourse)
export default WrappedComponent
